import { createSelector } from 'reselect'
// import { List } from 'immutable'
const leaveTypeSelector = state => state.get('leaveType')

export const getIsFetching = createSelector(
  leaveTypeSelector,
  leaveTypeImmutable => {
    const leaveType = leaveTypeImmutable.toJS()
    return leaveType.leaveTypeGet.isFetching
    || leaveType.leaveTypeList.isFetching
    || leaveType.leaveTypeEdit.isFetching
    || leaveType.leaveTypeCreate.isFetching
    || leaveType.leaveTypeDelete.isFetching
    || leaveType.leaveTypeExport.isFetching
  }
)
export const getLeaveTypeData = createSelector(
  leaveTypeSelector,
  leaveTypeImmutable => {
    const leaveType = leaveTypeImmutable.toJS()
    return leaveType.leaveTypeList.leaveTypes
  }
)
export const getLeaveTypeByIDData = createSelector(
  leaveTypeSelector,
  leaveTypeImmutable => {
    const leaveType = leaveTypeImmutable.toJS()
    return leaveType.leaveTypeGet.leaveType
  }
)
export const editLeaveTypeData = createSelector(
  leaveTypeSelector,
  leaveTypeImmutable => {
    const leaveType = leaveTypeImmutable.toJS()
    return leaveType.leaveTypeEdit
  }
)
export const createLeaveTypeData = createSelector(
  leaveTypeSelector,
  leaveTypeImmutable => {
    const leaveType = leaveTypeImmutable.toJS()
    return leaveType.leaveTypeCreate
  }
)
export const deleteLeaveTypeData = createSelector(
  leaveTypeSelector,
  leaveTypeImmutable => {
    const leaveType = leaveTypeImmutable.toJS()
    return leaveType.leaveTypeDelete
  }
)
export const getExportURL = createSelector(
  leaveTypeSelector,
  leaveTypeImmutable => {
    const leaveType = leaveTypeImmutable.toJS()
    return leaveType.leaveTypeExport.url
  }
)
export const redirectLeaveType = createSelector(
  leaveTypeSelector,
  leaveTypeImmutable => {
    const leaveType = leaveTypeImmutable.toJS()
    return ({
      redirect: (leaveType.leaveTypeGet.redirect
      || leaveType.leaveTypeList.redirect
      || leaveType.leaveTypeEdit.redirect
      || leaveType.leaveTypeCreate.redirect
      || leaveType.leaveTypeDelete.redirect
      || leaveType.leaveTypeExport.redirect),
      isAuthenticated: (leaveType.leaveTypeGet.isAuthenticated
      || leaveType.leaveTypeList.isAuthenticated
      || leaveType.leaveTypeEdit.isAuthenticated
      || leaveType.leaveTypeCreate.isAuthenticated
      || leaveType.leaveTypeDelete.isAuthenticated
      || leaveType.leaveTypeExport.isAuthenticated),
    })
  }
)



// WEBPACK FOOTER //
// ./src/selectors/leave-type/leave-type-selector.js